<template>
    <div class="africa-network">
        <div class="africa-network__content">
            <h2 v-html="title"></h2>
        </div>
        <div class="container">
            <div class="row">
                <div class="africa-network__col col-l-4 col-m-12" v-html="first"></div>
                <div class="africa-network__col col-l-4 col-m-12" v-html="second"></div>
                <div
                    class="africa-network__col africa-network__col--third col-l-4 col-m-12"
                    v-html="third"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "africa-network",
    data() {
        return {
            title: this.blockdata.title,
            first: this.blockdata.first_column,
            second: this.blockdata.second_column,
            third: this.blockdata.third_column
        };
    }
};
</script>


// WEBPACK FOOTER //
// AfricaNetwork.vue?bf5ccc32